import { defineMessages } from "react-intl";

export const messages = defineMessages({
  errorHeader: {
    id: "rovo-extension.error-header.label",
    defaultMessage: "Something went wrong",
    description: "Header label for extension error message",
  },
  chatErrorSubheader: {
    id: "rovo-extension.chat-error-subheader.label",
    defaultMessage: "Try refreshing the page, or starting a new chat.",
    description: "Subheader label for extension error message suggestions",
  },
  errorBoundarySubheader: {
    id: "rovo-extension.error-boundary-subheader.label",
    defaultMessage: "Please try again.",
    description: "Subheader label for extension error message",
  },
  rovoDisabledError: {
    id: "rovo-extension.rovo-disabled-error.label",
    defaultMessage: "Are you there Rovo?",
    description: "Header label for extension error message when Rovo is missing for the user's Atlassian site",
  },
  rovoDisabledErrorSubheader: {
    id: "rovo-extension.rovo-disabled-error-subheader.label",
    defaultMessage: "It looks like you don't have access to Rovo.",
    description: "Subheader label for extension error message when Rovo is disabled for the user's Atlassian site",
  },
  rovoDisabledErrorLink: {
    id: "rovo-extension.rovo-disabled-error-link.label",
    defaultMessage: "More about Rovo",
    description: "Link label for missing Rovo error message to redirect to more information about Rovo",
  },
  welcomeHeaderWithName: {
    id: "rovo-extension.welcome-header-with-name.label",
    defaultMessage: "What can I help you with, {name}?",
    description: "Header label for extension welcome message with user's name",
  },
  welcomeHeaderWithoutName: {
    id: "rovo-extension.welcome-header-without-name.label",
    defaultMessage: "What can I help you with?",
    description: "Header label for extension welcome message without user's name",
  },
  welcomeHeaderMorning: {
    id: "rovo-extension.welcome-header-morning.label",
    defaultMessage: "Good morning, {name}",
    description: "Header label for extension welcome message in the morning",
  },
  welcomeHeaderMorningNoName: {
    id: "rovo-extension.welcome-header-morning-no-name.label",
    defaultMessage: "Good morning",
    description: "Header label for extension welcome message in the morning when no name is provided",
  },
  welcomeHeaderAfternoon: {
    id: "rovo-extension.welcome-header-afternoon.label",
    defaultMessage: "Good afternoon, {name}",
    description: "Header label for extension welcome message in the afternoon",
  },
  welcomeHeaderAfternoonNoName: {
    id: "rovo-extension.welcome-header-afternoon-no-name.label",
    defaultMessage: "Good afternoon",
    description: "Header label for extension welcome message in the afternoon when no name is provided",
  },
  welcomeHeaderEvening: {
    id: "rovo-extension.welcome-header-evening.label",
    defaultMessage: "Good evening, {name}",
    description: "Header label for extension welcome message in the evening",
  },
  welcomeHeaderEveningNoName: {
    id: "rovo-extension.welcome-header-evening-no-name.label",
    defaultMessage: "Good evening",
    description: "Header label for extension welcome message in the evening when no name is provided",
  },
  reloadButtonLabel: {
    id: "rovo-extension.rovo-disabled-error.button",
    defaultMessage: "Try again",
    description: "Label for reload button when Rovo is disabled",
  },
});
